<template>
    <span class="control-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="66" height="66" viewBox="0 0 66 66">
            <defs>
                <filter id="q4oxectgda" width="147.9%" height="147.9%" x="-24%" y="-24%" filterUnits="objectBoundingBox">
                    <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1"/>
                    <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="1.5"/>
                    <feColorMatrix in="shadowBlurOuter1" result="shadowMatrixOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/>
                    <feMerge>
                        <feMergeNode in="shadowMatrixOuter1"/>
                        <feMergeNode in="SourceGraphic"/>
                    </feMerge>
                </filter>
            </defs>
            <g fill="none" fill-rule="evenodd" filter="url(#q4oxectgda)" transform="translate(9 9)">
                <circle cx="24" cy="24" r="24" stroke="#FFF"/>
                <g transform="translate(8.64 9.6)">
                    <rect width="11.52" height="14.4" x="10.56" y="8.64" fill="#FFF" rx="1"/>
                    <g>
                        <path stroke="#FFF" stroke-linecap="round" d="M12.48 0C7.708 0 3.84 3.868 3.84 8.64" transform="rotate(14 -.139 15.499)"/>
                        <path fill="#FFF" d="M3.332 12.545l-1.81-3.264c-.134-.241-.047-.545.195-.68.082-.045.175-.066.268-.061l3.95.207c.277.014.488.25.474.525-.005.094-.036.184-.09.26L4.18 12.59c-.16.226-.47.28-.697.122-.062-.043-.114-.1-.15-.167z" transform="rotate(14 -.139 15.499)"/>
                    </g>
                </g>
            </g>
        </svg>
        <i>
            Rotate video
        </i>
    </span>
</template>

<script>
export default {
    name: 'rotate-video'
}
</script>

<style lang="scss" scoped>
@import "style.scss";
</style>